"use client";

import Image from "next/image";

import { useLoyaltyBrandContext } from "@saas/loyalty/feature/@context/loyalty-brand/loyalty-brand.context";

export const BrandHeader = () => {
  const { brandName, logoUrl } = useLoyaltyBrandContext();

  return (
    <div
      className={"relative h-12 w-1/2"}
      data-testid={"header__image__brand-logo"}
    >
      <Image
        alt={`${brandName} logo`}
        className={"object-contain object-left"}
        src={logoUrl}
        fill={true}
      />
    </div>
  );
};
